import {
  createStyles,
  stylize,
  Theme,
  WithStyles,
} from "@envestnet/envreact-component-library";
import classNames from "classnames";
import AccountLocked from "components/AccountLocked";
import CentricLayout from "components/CentricLayout";
import Logo from "images/Logo";
import React, { CSSProperties } from "react";
import withIntl from "utils/withIntl";

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    header: {
      ...theme.fonts.h2,
    },
  });

type DefaultProps = {};

export type Props = DefaultProps & {
  className?: string;
  style?: CSSProperties;
};

const defaultProps: DefaultProps = {};

const AppErrorActual = ({
  classes,
  className,
  style,
}: Props & WithStyles<typeof styles>) => (
  <div className={classNames(classes.root, className)} style={style}>
    <CentricLayout>
      <>
        <Logo />
        <AccountLocked type="ERROR" />
      </>
    </CentricLayout>
  </div>
);

AppErrorActual.defaultProps = defaultProps;

export const AppError = withIntl(
  stylize<Props, DefaultProps>(styles)(AppErrorActual)
);
